export const GET_INITIATIVES_REQUEST = 'GET_INITIATIVES_REQUEST';
export const GET_INITIATIVES_SUCCESS = 'GET_INITIATIVES_SUCCESS';
export const GET_INITIATIVES_FAILED = 'GET_INITIATIVES_FAILED';

export const DELETE_INITIATIVE_REQUEST = 'DELETE_INITIATIVE_REQUEST';
export const DELETE_INITIATIVE_SUCCESS = 'DELETE_INITIATIVE_SUCCESS';
export const DELETE_INITIATIVE_FAILED = 'DELETE_INITIATIVE_FAILED';

export const TRIGGER_PETITION_IMPORT_SCAN_REQUEST = 'TRIGGER_PETITION_IMPORT_SCAN_REQUEST';
export const TRIGGER_PETITION_IMPORT_SCAN_SUCCESS = 'TRIGGER_PETITION_IMPORT_SCAN_SUCCESS';
export const TRIGGER_PETITION_IMPORT_SCAN_FAILED = 'TRIGGER_PETITION_IMPORT_SCAN_FAILED';
